import { render, staticRenderFns } from "./ProductAttach.vue?vue&type=template&id=494566ec"
import script from "./ProductAttach.vue?vue&type=script&lang=js"
export * from "./ProductAttach.vue?vue&type=script&lang=js"
import style0 from "./ProductAttach.vue?vue&type=style&index=0&id=494566ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports